import React from 'react';

const Location = (props) => {
    return (
        <div className="container">
            <div className="row">
                <div className="box">
                    <div className="col-lg-12">
                        <hr />
                        <h2 className="intro-text text-center">Kontakt</h2>
                        <hr />
                    </div>
                    <div className="col-md-8">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d2781.2685972512054!2d15.950118515568908!3d45.80587887910648!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x4765d6c2f580b0e1%3A0xab2aaba2a6b4e079!2zVHJnIEtyZcWhaW1pcmEgxIZvc2nEh2EgOSwgMTAwMDAsIFphZ3JlYg!3m2!1d45.805878899999996!2d15.9523072!5e0!3m2!1sen!2shr!4v1490549913261" width="100%" height="400" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"></iframe>
                    </div>
                    <div className="col-md-4">
                        <p>Email:
                            <strong><a href="mailto:tk.vamos@yahoo.com"> tk.vamos@yahoo.com</a></strong>
                        </p>
                        <p>Telefon:
                            <strong> 00385 95 5220 151</strong>
                        </p>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        </div>
    );
}

export default Location



// WEBPACK FOOTER //
// ./src/components/Location.js